/* eslint-disable import/extensions */
import request, { IServerResponse } from '@/utils/request';
import { PageReq, SubmitReq, GetDownloadDetail, ICooperateList, IPermissionRes } from './define';

// 查询服务商下载任务总数
export const getAnalysisDownloadCount = (): Promise<IServerResponse<number>> =>
    request.get('/api/thirdpartnar/data/analysis/download/count');

// 查询服务商下载任务列表（操作时间倒叙排列）
export const getAnalysisDownloadLinkList = (
    parmas: PageReq,
): Promise<IServerResponse<GetDownloadDetail[]>> =>
    request.get('/api/thirdpartnar/data/analysis/download/linkList', parmas);

//发起数据查询任务
export const getAnalysisDownloadSubmit = (parmas: SubmitReq): Promise<IServerResponse<string>> =>
    request.post('/api/thirdpartnar/data/analysis/download/submit', parmas);

//获取全部（代运营）合作模式列表
export const getAllCoopmode = (parmas: {
    customSource: number;
}): Promise<IServerResponse<ICooperateList>> =>
    request.get('/api/thirdpartnar/coopmode/list', parmas);

// 判断服务商权限，是否支持下载直播相关的报表
export const getProviderPermission = (): Promise<IServerResponse<IPermissionRes>> =>
    request.get('/api/thirdpartnar/data/analysis/live/permission');
